import React, { useState } from 'react';
import { Container } from './styles';
import { CircularProgress } from '@mui/material';
import theme from '../../theme/theme';

export const Spinner = () => {
    return (
        <Container>
            <CircularProgress size={"10%"}  sx={{ color: theme.color.navy }} />
        </Container>
    );
};

export default Spinner;